import React from "react"

import { TextBig } from "@tenforce/product-fields"

import { Labels } from "../../../../../util/Translations"

import { ICheckListViewActions, IQuestion } from "../../.."

export interface Props extends IQuestion {
    contextMenuActions: ICheckListViewActions
}

export const TextFieldValue = ({
    data,
    id,
    contextMenuActions: { updateSimpleValue },
    controls: { canEditValue },
}: Props): JSX.Element => {
    const currentValue = data as string

    const { ClickHereToEdit } = Labels

    return (
        <TextBig
            value={currentValue}
            placeholder={ClickHereToEdit}
            isReadOnly={!canEditValue}
            fieldId="textAnswer"
            isLoading={false}
            onSave={(value): void => {
                updateSimpleValue(id, value)
            }}
        />
    )
}

export default TextFieldValue
